// extracted by mini-css-extract-plugin
module.exports = {"HeroWrap":"CourseHero_HeroWrap__7r73W","HeroTitle":"CourseHero_HeroTitle__8_Yjh","HeroSubTitle":"CourseHero_HeroSubTitle__K6Tju"};